import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/common/copy_icon.png'
import _imports_1 from '@/assets/profile/home_email.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "head_card" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "id" }
const _hoisted_5 = { class: "contact" }
const _hoisted_6 = { class: "value" }

import StatusPopup from '@/components/common/statusPopup.vue';
import { useUserStore } from '@/stores/user';
import { formatCurrency } from '@/utils/commonFunction';
import { buttonClick, clickOnCard, copyID } from '@/view/profile/supportScript';
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import PrimaryButton from '../../components/common/primaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'headCard',
  setup(__props) {

const router = useRouter()
const statusRef = ref();
const userStore = useUserStore()
const name = computed(() => userStore.nickname)
const balance = computed(() => userStore.balance)
const id = computed(() => userStore.id)
const headImg = computed(() => userStore.headimg)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isPopping = ref(false)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-message')
const onCopyID = (id : any) => copyID(statusRef, id)
const onButtonClick = (type: string) => buttonClick(router, type)


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_badge = _resolveComponent("van-badge")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "6",
            class: "avatar"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: headImg.value || require('@/assets/common/head_icon.jpg'),
                alt: ""
              }, null, 8, _hoisted_3)
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, { span: "14" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.$t('profile.id')) + " : " + _toDisplayString(id.value) + " ", 1),
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onCopyID(id.value)))
                })
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('profile.account')) + " : " + _toDisplayString(name.value), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_unref(formatCurrency)(balance.value)), 1),
                _cache[3] || (_cache[3] = _createTextVNode(" R$"))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "4",
            class: "mail"
          }, {
            default: _withCtx(() => [
              (unreadMsgCount.value > 0)
                ? (_openBlock(), _createBlock(_component_van_badge, {
                    key: 0,
                    content: unreadMsgCount.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _imports_1,
                        alt: "",
                        onClick: onClickCard,
                        class: _normalizeClass({ 'pop-animate': isPopping.value })
                      }, null, 2)
                    ]),
                    _: 1
                  }, 8, ["content"]))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: _imports_1,
                    alt: "",
                    onClick: onClickCard,
                    class: _normalizeClass({ 'pop-animate': isPopping.value })
                  }, null, 2))
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "withdraw_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                icon: require('@/assets/sideNavbar/home_withdrawal.png'),
                text: _ctx.$t('common.sake'),
                textColor: "#FFFFFF",
                bgColor: "#3d2e22",
                onOnClick: _cache[1] || (_cache[1] = ($event: any) => (onButtonClick('withdraw')))
              }, null, 8, ["icon", "text"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "12",
            class: "deposit_btn"
          }, {
            default: _withCtx(() => [
              _createVNode(PrimaryButton, {
                icon: require('@/assets/sideNavbar/home_recharge.png'),
                text: _ctx.$t('common.deposite'),
                textColor: "#000",
                bgColor: "linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%)",
                onOnClick: _cache[2] || (_cache[2] = ($event: any) => (onButtonClick('topup')))
              }, null, 8, ["icon", "text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      content: _ctx.$t('common.copied'),
      isShowSuccess: true
    }, null, 8, ["content"])
  ]))
}
}

})